import React from 'react';
import { FaCheck } from 'react-icons/fa';

type LinkCopiedSuccessProps = {
  className?: string;
};

export const LinkCopiedSuccess: React.FC<LinkCopiedSuccessProps> = ({
  className = '',
}) => {
  return (
    <div
      className={`tw:inline-flex tw:items-center tw:gap-2 tw:text-green-600 ${className}`}
    >
      <FaCheck className="tw:text-green-600" />
      <span className="tw:text-sm tw:font-medium">copied</span>
    </div>
  );
};
